import queries from '@apis/queries';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useCookies } from 'react-cookie';

function useUser() {
    const [cookies] = useCookies(['refreshToken']);
    const { refreshToken } = cookies;
    const enabled = !!refreshToken;
    const { data: user, status } = useQuery({
        ...queries.user.profile(),
        enabled,
        retry: 2,
    });
    const queryClient = useQueryClient();
    const getUserProfile = useCallback(() => {
        queryClient.invalidateQueries({ queryKey: queries.user.profile._def });
    }, [refreshToken]);
    const isLoading = status === 'pending' && enabled;
    return { user, getUserProfile, isLoading };
}

export default useUser;
